import { optionSchema } from "@/common/schemas/option.schema";
import { z } from "zod";

export const requestNewCardSchema = z.object({
  request_reason: optionSchema,
  request_observation: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
});

export type RequestNewCardValidationSchema = z.infer<typeof requestNewCardSchema>;
